module.exports = __webpack_public_path__ + "img/fluorescence.47dc18d.webp";